export default __webpack_public_path__ + "static/SourceSansPro-Regular-df87f53caf449a3b757216001bee697d.ttf";